export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxUl0c_SjTjQJElti5.7ddef1e4.woff2";